const drawerStyles = {
    drawer: (drawerWidth) => ({
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#2c2c2c",
            color: "#fff",
        },
    }),
};

const buttonStyles = {
    listItemButton: (isActive) => ({
        minHeight: 48,
        pl: 3,
        color: "#fff",
        mx: 2,
        my: 0.15,
        borderRadius: 2,
        backgroundColor: isActive ? "#464646" : "transparent",
        "&:hover": {
            backgroundColor: isActive ? "#464646" : "#3c3c3c",
        },
    }),
};

export { drawerStyles, buttonStyles };
